import { contactListApi as api } from './contactListApi';
export const addTagTypes = ['user'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      userContactsList: build.query<
        UserContactsListApiResponse,
        UserContactsListApiArg
      >({
        query: queryArg => ({
          url: `/user/contacts/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset,
            role: queryArg.role,
            name: queryArg.name,
            country_id: queryArg.countryId,
            city: queryArg.city,
            zip_code: queryArg.zipCode,
            street_address: queryArg.streetAddress,
            phone_number: queryArg.phoneNumber,
            email: queryArg.email,
            state_director: queryArg.stateDirector,
            district_lead: queryArg.districtLead
          }
        }),
        providesTags: ['user']
      }),
      userContactsLocalLeads: build.query<
        UserContactsLocalLeadsApiResponse,
        UserContactsLocalLeadsApiArg
      >({
        query: queryArg => ({
          url: `/user/contacts/local_leads/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['user']
      }),
      userContactsStateDirectors: build.query<
        UserContactsStateDirectorsApiResponse,
        UserContactsStateDirectorsApiArg
      >({
        query: queryArg => ({
          url: `/user/contacts/state_directors/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['user']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type UserContactsListApiResponse = /** status 200 Custom Response */ {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results: ContactRead[];
  ok?: boolean;
  message?: {
    text?: string | null;
    code?: number;
    args?: object | null;
  };
};
export type UserContactsListApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** for users local leader and state director  */
  role?: string;
  /** search by name */
  name?: string;
  /** filter by country uuid */
  countryId?: string;

  city?: string;
  zipCode?: string;
  state?: string;
  streetAddress?: string;
  phoneNumber?: string;
  email?: string;
  stateDirector?: string;
  districtLead?: string;
};
export type UserContactsLocalLeadsApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: ContactRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserContactsLocalLeadsApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type UserContactsStateDirectorsApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: ContactRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserContactsStateDirectorsApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type ZipDetail = {
  zip: string;
  district_lead: string;
  state_director: string;
  country_director: string;
};
export type Contact = {
  first_name?: string;
  last_name?: string;
  email: string;
  groups: string;
  contact_number: string;
  start_date: string;
  zip_details: ZipDetail;
  district: string;
  state: string;
  country?: string;
};
export type ContactRead = {
  uuid?: string;
  first_name?: string;
  last_name?: string;
  email: string;
  groups: string;
  contact_number: string;
  start_date: string;
  zip_details: ZipDetail;
  district: string;
  state: string;
  country?: string;
};
export const {
  useUserContactsListQuery,
  useUserContactsLocalLeadsQuery,
  useUserContactsStateDirectorsQuery
} = injectedRtkApi;
